export const EntryDate = "Entry Date"
export const Name = "Name";
export const Category = "Category";
export const Cuisine = "Cuisine";
export const Form = "Form";
export const Time = "Time";
export const Method = "Method";
export const Vegetarian = "Vegetarian";
export const Ingredients = "Ingredients";
export const Notes = "Notes";
export const Link = "Link";
export const Image = "Image";
export const Lists = "Lists";

export const Columns = [
  EntryDate,
  Name,
  Category,
  Cuisine,
  Form,
  Time,
  Method,
  Vegetarian,
  Ingredients,
  Notes,
  Link,
  Image,
  Lists,
];

export const MinTime = "MinTime";
export const MaxTime = "MaxTime";
export const Keyword = "Keyword";
export const ExcludeIngredient = "ExcludeIngredient";
export const ExcludeKeyword = "ExcludeKeyword";

export const KeywordQueryOptions = [
  Name,
  Category,
  Cuisine,
  Form,
  Method,
  Ingredients,
];

export const AllQueryOptions = [
  ...Columns.filter((column) => column !== Time),
  MinTime,
  MaxTime,
  Keyword,
  ExcludeIngredient,
  ExcludeKeyword,
];

const entries = AllQueryOptions.map((query) => {
  return [[query], []];
});
export const AllQueryOptionsObject = Object.fromEntries(entries);

export const VegetarianYes = "y";
export const VegetarianMaybe = "m";
export const VegetarianNo = "n";

export const LocalStorageRecipeIndex = "index";
export const LocalStorageUrl = "url";
export const LocalStorageDate = "date";

// Official MAK recipe spreadsheet.
export const DefaultUrl =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vQhCJwjwllxAvd5C4_m0S2nXY-yVoHMCkdp5jUhDPMPuv0a1qGSU2KLvxeQlTbOU6QSxEdiZWxXgzx-/pub?output=csv";
